import React, { useEffect, useEffectEvent, useState } from 'react'
import { useParams } from 'react-router-dom'
import { CreditApplicationStatus } from '_gql'

import useApplicantTokenOnMount from '@sputnik/hooks/useApplicantTokenOnMount'

import AcceptingOfferPollingPageContent from './AcceptingOfferPollingPageContent'
import { useGetApplicationStatusForPolling } from './GetApplicationStatusForPolling.gql'

const POLLING_MAX_TIMEOUT = 60000
const POLLING_RATE = 5000
const { OFFER_ACCEPTED, MORE_INFO_NEEDED, CORRECTION_REQUESTED, IN_REVIEW } = CreditApplicationStatus
const readyToRedirectStatesV3 = [OFFER_ACCEPTED, MORE_INFO_NEEDED, CORRECTION_REQUESTED, IN_REVIEW]

const AcceptingOfferPollingPage = () => {
  /* make sure we have a token before we start polling */
  const { appId } = useParams()
  useApplicantTokenOnMount({ salesforceCreditId: appId || '' })

  const [isReadyToNavigate, setIsReadyToNavigate] = useState(false)
  const onReadyToNavigate = useEffectEvent(() => setIsReadyToNavigate(true))
  const [timer, setTimer] = useState(0)

  const { data, loading, startPolling, stopPolling } = useGetApplicationStatusForPolling({
    fetchPolicy: 'network-only',
    skip: !appId,
    variables: { creditApplicationId: appId as string },
  })

  const { status, authorizedSigner } = data?.creditApplication || {}

  const hasPollingTimedOut = timer >= POLLING_MAX_TIMEOUT
  const readyToRedirectStates = readyToRedirectStatesV3
  const invitationToken = authorizedSigner?.accountSetupInvitation?.token ?? undefined
  const shouldNavigateImmediatelyStatus =
    !!status && (readyToRedirectStates.includes(status) || !!invitationToken) && timer >= POLLING_RATE

  const finishedPolling = (hasPollingTimedOut || shouldNavigateImmediatelyStatus) && !loading && !!data

  // handle polling
  useEffect(() => {
    startPolling(POLLING_RATE)
    if (hasPollingTimedOut) {
      onReadyToNavigate()
    } else {
      setTimeout(() => setTimer(timer + POLLING_RATE), POLLING_RATE)
    }
  }, [hasPollingTimedOut, startPolling, stopPolling, timer])

  return (
    <AcceptingOfferPollingPageContent
      key={isReadyToNavigate.toString()}
      invitationToken={invitationToken}
      isReadyToNavigate={finishedPolling || isReadyToNavigate}
      stopPolling={stopPolling}
    />
  )
}

export default AcceptingOfferPollingPage
